import { uiActions } from './ui-slice';
import { catalogsActions } from './catalogs-slice';
import { verifyErrors } from '../utils/helper-functions';

import {
  getBrands,
  getSubbrands,
  getModels,
  getVersions,
  getActivities,
  getNationalities,
  getGenders,
  getMaritalStatuses,
  getOccupations,
  getSEPOMEX,
  getPersonType,
  getUsesOftheVehicle,
  getVehiclesTypes,
  getVehicleServices,
  getBeneficiaries,
  getTaxRegimes,
} from '../requests/catalogs';

/**
 * EXPORTS FOR EXECUTION IN CERTAIN FORMS
 */
// FORM 2
export const form2BrandsCatalog = (token, typeVehicle) => {
  return async (dispatch) => {
    Promise
      .all([getBrands(token, typeVehicle)])
      .then((res) => {
        const responseData = res[0]
          && res[0].status === 200
          && res[0].data
          && res[0].data.data;

        if (responseData.length > 0) {
          dispatch(catalogsActions.setBrands({ brands: responseData }));
        } else {
          throw new Error('Error loading brands');
        }
      })
      .catch((err) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar las marcas de autos.',
        }));
        throw err;
      })
      .finally(() => {
        dispatch(uiActions.clearLoaderStatus());
      });
  };
};

export const form2SubbrandsCatalog = (token, typeVehicle, brand) => {
  return async (dispatch) => {
    Promise
      .all([getSubbrands(token, typeVehicle, brand)])
      .then((res) => {
        const responseData = res[0]
          && res[0].status === 200
          && res[0].data
          && res[0].data.data
          && res[0].data.data.subBrands;
        if (responseData.length > 0) {
          dispatch(catalogsActions.setSubbrands({ subbrands: responseData }));
        } else {
          throw new Error('Error loading subbrands');
        }
      })
      .catch((err) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar las submarcas de autos.',
        }));
        throw err;
      })
      .finally(() => {
        dispatch(uiActions.clearLoaderStatus());
      });
  };
};

export const form2ModelsCatalog = (token, typeVehicle, brand, subbrand) => {
  return async (dispatch) => {
    Promise
      .all([getModels(token, typeVehicle, brand, subbrand)])
      .then((res) => {
        const responseData = res[0]
          && res[0].status === 200
          && res[0].data
          && res[0].data.data
          && res[0].data.data.models;

        if (responseData.length > 0) {
          dispatch(catalogsActions.setModels({ models: responseData }));
        } else {
          throw new Error('Error loading models');
        }
      })
      .catch((err) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar los models de autos.',
        }));
        throw err;
      })
      .finally(() => {
        dispatch(uiActions.clearLoaderStatus());
      });
  };
};

export const form2VersionsCatalog = (token, typeVehicle, brand, subbrand, model) => {
  return async (dispatch) => {
    Promise
      .all([getVersions(token, typeVehicle, brand, subbrand, model)])
      .then((res) => {
        const responseData = res[0]
          && res[0].status === 200
          && res[0].data
          && res[0].data.data
          && res[0].data.data.versions;

        if (responseData.length > 0) {
          dispatch(catalogsActions.setVersions({ versions: responseData }));
        } else {
          throw new Error('Error loading versions');
        }
      })
      .catch((err) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar las versiones de autos.',
        }));
        throw err;
      })
      .finally(() => {
        dispatch(uiActions.clearLoaderStatus());
      });
  };
};

export const form4FetchCatalogs = (token) => {
  return (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    Promise
      .all([
        getActivities(token),
        getNationalities(token),
        getGenders(token),
        getMaritalStatuses(token),
        getOccupations(token),
        getPersonType(token),
        getTaxRegimes(token),
      ])
      .then((response) => {
        dispatch(catalogsActions.setActivities({ activities: response[0].data }));
        dispatch(catalogsActions.setNationalities({ nationalities: response[1].data }));
        dispatch(catalogsActions.setGenders({ genders: response[2].data }));
        dispatch(catalogsActions.setMaritalStatuses({ maritalStatuses: response[3].data }));
        dispatch(catalogsActions.setOccupations({ occupations: response[4].data }));
        dispatch(catalogsActions.setPersonType({ personType: response[5].data }));
        dispatch(catalogsActions.setTaxRegimes({ taxRegimes: response[6].data }));
        dispatch(uiActions.clearLoaderStatus());
      }).catch((error) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar los datos del formulario.',
        }));
        throw error;
      });
  };
};

export const fetchUsesOfTheVehicle = (token, typeId) => {
  return (dispatch) => {
    getUsesOftheVehicle(token, typeId)
      .then((response) => {
        dispatch(catalogsActions.setUsesOfTheVehicle({ usesOfTheVehicle: response.data }));
      })
      .catch((error) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar los datos del formulario.',
        }));
        throw error;
      })
      .finally(() => dispatch(uiActions.clearLoaderStatus()));
  };
};

export const form6FetchCatalogs = (token) => {
  return (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    Promise
      .all([
        getVehiclesTypes(token),
        getVehicleServices(token),
        getBeneficiaries(token),
      ])
      .then((response) => {
        dispatch(catalogsActions.setVehiclesTypes({ vehiclesTypes: response[0].data }));
        dispatch(catalogsActions.setVehicleServices({ vehicleServices: response[1].data }));
        dispatch(catalogsActions.setBeneficiaries({
          preferredBeneficiary: response[2].data.find((p) => p.name === 'NINGUNO'),
        }));
        dispatch(fetchUsesOfTheVehicle(token, response[1].data[0].id));
      }).catch((error) => {
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: 'Hubo un error al cargar los datos del formulario.',
        }));
        throw error;
      });
  };
};

export const fetchPostalCodeData = (
  token,
  postalCode,
  setStateAndMunicipality,
  setError,
) => {
  return async (dispatch) => {
    getSEPOMEX(token, postalCode).then(
      (response) => {
        verifyErrors(response);
        const { data: { municipio: municipality, estado: state, colonias: colonies } } = response;
        dispatch(catalogsActions.setColonies({ colonies }));
        setStateAndMunicipality(state, municipality);
      },
    ).catch((err) => {
      if (err.response && err.response.data) {
        setError(err.response.data.message);
      } else if (err.message) {
        setError(err.message);
      } else {
        setError('*Código postal inválido.');
      }
      throw err;
    });
  };
};
